import { useContext, useEffect } from "react";
import "../../../styles/style.css";
import { useLocation } from "react-router";
import { invoiceTabContext, invoiceCurrentTabContext } from "../context/invoice_context";

const InvoiceTab = () => {
  const { tabs } = useContext(invoiceTabContext);
  const location = useLocation();
  const { currentTab, setTab, setTabByValue } = useContext(invoiceCurrentTabContext);

  useEffect(() => {
    if (location.state && location.state.tabValue !== undefined) {
      setTabByValue(location.state.tabValue);
    }
  }, []);

  return (
    <div className="sm:block pb-4">
      <nav className="flex space-x-4" aria-label="Tabs">
        {tabs.map((tab) => (
          <button
            key={tab.name}
            onClick={() => setTab(tab)}
            className={`button-tab-base ${tab.name === currentTab.name ? "active" : "inactive"}`}
            aria-current={tab.name === currentTab.name ? "page" : undefined}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default InvoiceTab;
